import { FC, useMemo } from 'react'

import useFollowUpReabAlert from '@hook/alerts/use-followup-reab'
import useTable from '@hook/shared/use-table'

import TableGridCollpseFollowUpReab from './item-collapse-reab'

const TableGridBodyFollowUpReab: FC = () => {
  const { data: rows } = useTable()
  const { data } = useFollowUpReabAlert()

  const group = useMemo(() => {
    let purchases: any[] = []
    const rowsDistinct = data
      .map(item => item['general-pedido'])
      .filter((value, index, self) => self.indexOf(value) === index)
    for (const rows of rowsDistinct) {
      purchases = [
        ...purchases,
        data.filter((x: any) => x['general-pedido'] === rows)
      ]
    }
    return rowsDistinct
  }, [data])
  return (
    <tbody>
      {rows.data.length === 0 ? (
        <tr>
          <td colSpan={12} align="center">
            Dados não encontrados
          </td>
        </tr>
      ) : (
        group.map(value => (
          <>
            <TableGridCollpseFollowUpReab filterDate={value} />
          </>
        ))
      )}
    </tbody>
  )
}
export default TableGridBodyFollowUpReab
